import { Checkbox, type CheckboxProps, Box, useTheme } from "@mui/material";
import CheckIcon from "@/modules/common/components/ui-kit/icons/check-icon";

interface CircularCheckboxProps
  extends Omit<CheckboxProps, "icon" | "checkedIcon" | "size"> {
  size?: number;
  variant?: "rounded" | "square";
}

export default function CircularCheckbox({
  size = 40,
  variant = "rounded",
  ...props
}: CircularCheckboxProps) {
  const theme = useTheme();
  return (
    <Checkbox
      {...props}
      icon={
        <Box
          sx={{
            width: size,
            height: size,
            borderRadius:
              variant === "rounded" ? "50%" : theme.nawy.radius.md,
              border: `2px solid ${ props.checked ? theme.nawy.colors.semantic.layer.accent : theme.nawy.colors.semantic.border.primary}`,
            backgroundColor: "transparent",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        />
      }
      checkedIcon={
        <Box
          sx={{
            width: size,
            height: size,
            borderRadius:
              variant === "rounded" ? "50%" : theme.nawy.radius.md,
            backgroundColor: theme.nawy.colors.primitives.blue[500],
            border: `2px solid ${theme.nawy.colors.primitives.blue[500]}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CheckIcon size={size} />
        </Box>
      }
      sx={{
        padding: 0,
        "&:hover": {
          backgroundColor: "transparent",
        },
        "&.Mui-focusVisible": {
          backgroundColor: "transparent",
        },
      }}
    />
  );
}
